import { createContext, useState, useRef, useEffect, useMemo } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalConfig';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState('');
  const [authorized, setAuthorized] = useState(false); // Novo estado para login direto
  const [level, setLevel] = useState(null); // Adicionando o estado de level
  const [isManager, setIsManager] = useState(false); // Feature Gestão de Grupos: flag independente de level
  const [domainsAccess, setDomainsAccess] = useState([]); // Domínios que o usuário tem acesso
  const [email, setEmail] = useState('');
  const [date, setDate] = useState('');
  const [count, setCount] = useState(0);
  const [sessionId, setSessionId] = useState('');
  const [assistantList, setAssistantList] = useState([]);
  const [userEmailFromLogin, setUserEmail] = useState('');
  const [accessToken, setAccessToken] = useState('1');
  const [popupStatus, setPopupStatus] = useState(''); // Status do popup de atualizações
  const [updateId, setUpdateId] = useState(null); // ID da atualização atual
  const [termsAccepted, setTermsAccepted] = useState(null); // Status de aceitação dos termos (null = não verificado, false = não aceitou, true = aceitou) 
  const [isLogin, setIsLogin] = useState(false); // verifica se fez o login para mostrar o popup
  const [neverSee, setNeverSee] = useState('see'); // verifica se selecionou o prefiro nao ver mais da galeria
  const [access, setAccess] = useState(null);
  const [resourceGroup, setResourceGroup] = useState(null);
  const [resourceLoading, setResourceLoading] = useState(false);
  const [resourceError, setResourceError] = useState(null);
  const hasFetched = useRef(false); // Ref para controlar se a busca já foi feita

  const userDomain = useMemo(() => {
    if (!email) return null;

    return email.split('@')[1]?.toLowerCase().trim();
  }, [email]);

  const fetchResourceGroup = async (token) => {
    if (!userDomain) return;

    setResourceLoading(true);
    setResourceError(null);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/get_all_resource_group`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) throw new Error('Erro ao buscar resource group');

      const json = await res.json();

      const matched = json.resource_group?.filter(rg =>
        rg.domains?.some(d => d.toLowerCase() === userDomain)
      ) ?? [];
      
      setResourceGroup(matched);

    } catch (err) {
      setResourceError(err.message);
    } finally {
      setResourceLoading(false);
    }
  };

  useEffect(() => {
    // Só executa se tiver token, domínio, e ainda não tiver buscado
    if (!accessToken || !userDomain || hasFetched.current) return;

    hasFetched.current = true;
    fetchResourceGroup(accessToken);

  }, [accessToken, userDomain]); // fetchResourceGroup fora das deps

  const getUserDomain = () => {
    if (user) {
      return user.username.split('@')[1]; // Extrair o domínio do email
    }
    return null;
  };


  // Função para gerar o novo session_id com base no novo count
  const newSessionId = () => {
    const newCount = count + 1;
    setCount(count + 1);
    // Geração do session_id no formato "user-newCount-date"
    const newSessionId = `${user}-${newCount}-${date}`;
    setSessionId(newSessionId);
    return newSessionId;
  };

  return (
    <MsalProvider instance={msalInstance}>
      <AuthContext.Provider
        value={{
          user, setUser,
          level, setLevel,
          isManager, setIsManager,
          domainsAccess, setDomainsAccess,
          email, setEmail,
          date, setDate,
          count, setCount,
          sessionId, setSessionId,
          assistantList, setAssistantList,
          getUserDomain,
          userName, setUserName,
          userEmailFromLogin, setUserEmail,
          newSessionId,
          accessToken, setAccessToken,
          updateId, setUpdateId,
          popupStatus, setPopupStatus,
          termsAccepted, setTermsAccepted,
          isLogin, setIsLogin,
          neverSee, setNeverSee,
          access, setAccess,
          resourceGroup, setResourceGroup,
          resourceLoading,
          resourceError,
          fetchResourceGroup
        }}>
        {children}
      </AuthContext.Provider>
    </MsalProvider>
  );
};